import { MessageService } from './../services/message.service';
import { Message } from './../common/message';
import { StockService } from './../services/stock.service';

import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Stock } from './../models/stock';
import { MatDialog } from '@angular/material';
import { ConfirmDeleteDialogComponent } from '../dialog/confirm-delete-dialog/confirm-delete-dialog.component';

let ELEMENT_DATA = [];
@Component({
  selector: 'app-stock',
  templateUrl: './stock.component.html',
  styleUrls: ['./stock.component.scss']
})
export class StockComponent implements OnInit {

  form: FormGroup;
  submitted = false;
  success = false;
  ELEMENT_DATA: any[];
  displayedColumns: string[] = ['SN','name', 'tel', 'manager', 'address', 'actions'];
  dataSource = new MatTableDataSource();

  @ViewChild(MatPaginator) paginator: MatPaginator;

  isFormDisplay: boolean = false;
  isAddNew: boolean = true;
  resource: any;

  constructor(private dialog : MatDialog,private service: StockService, private formBuilder: FormBuilder, private msg : MessageService) { }

  ngOnInit() {
    this.resource = new Stock();
    this.setMessageForm();
    this.getResources();
  }

  setMessageForm() {
    this.form = this.formBuilder.group({
      name: ['', Validators.required],
      tel: ['', Validators.required],
      manager: ['', Validators.required],
      address: ['', Validators.required]
    });
  }

  getResources() {
    ELEMENT_DATA  = [];
    this.service.getAll()
      .subscribe(result => {
        ELEMENT_DATA = ELEMENT_DATA.concat(result);
        this.updateDataSource();
      })
  }

  updateDataSource() {
    this.dataSource = new MatTableDataSource<any>(ELEMENT_DATA);
    this.dataSource.paginator = this.paginator;
  }

  displayForm() {
    this.resource = new Stock();
    this.isFormDisplay = true;
  }

  displayTable() {
    this.isFormDisplay = false;
  }

  onSave(name: HTMLDataElement, tel: HTMLDataElement, manager: HTMLDataElement, address: HTMLDataElement) {

    this.submitted = true;

    if (this.form.controls.name.errors) {
      return;
    }

    if (this.resource.id) {
      this.updateElement(name, tel, manager, address);
    } else {
      this.addElement(name, tel, manager, address);
    }

  }

  resetForm(ret? : boolean ) {
    this.form.reset();
    this.submitted = false;
    if(ret) this.isFormDisplay = false;
  }



  addElement(name, tel, manager, address) {
    this.resource.setName(name.value);
    this.resource.setTel(tel.value);
    this.resource.setManager(manager.value);
    this.resource.setAddress(address.value);

    this.service.create(this.resource)
      .subscribe(result => {
        this.msg.alert(Message.SAVE);
        ELEMENT_DATA.push(result);
        this.updateDataSource();
        this.resource = new Stock();
        this.resetForm();
      }, (err : any) => {
        if(err.status == 422){
          this.msg.alert(Message.ADDED_BEFORE_PLAESE_CHECK);
        }
      })
  }

  updateElement(name, tel, manager, address) {
    this.resource.setName(name.value);
    this.resource.setTel(tel.value);
    this.resource.setManager(manager.value);
    this.resource.setAddress(address.value);

    this.service.update(this.resource)
      .subscribe(result => {
        this.msg.alert(Message.UPDATE);
        ELEMENT_DATA.forEach((elem, index) => {
          if (elem.id === this.resource.id){
            ELEMENT_DATA.splice(index, 1, result);
            return;
          }
        })

        this.updateDataSource();
        this.resource = new Stock();
        this.resetForm(true);
      }, (err : any) => {
        if(err.status == 422){
          this.msg.alert(Message.ADDED_BEFORE_PLAESE_CHECK);
        }
      })
  }

  editElement(ele) {

    this.isFormDisplay = true;
    this.isAddNew = false;
    this.resource = ele;
    this.resource = new Stock();

    this.resource.setId(ele.id);
    this.resource.setName(ele.name);
    this.resource.setTel(ele.tel);
    this.resource.setAddress(ele.address);
    this.resource.setManager(ele.manager);

    this.form.controls.name.setValue(ele.name);
    this.form.controls.manager.setValue(ele.manager);
    this.form.controls.tel.setValue(ele.tel);
    this.form.controls.address.setValue(ele.address);

  }

  deleteElement(ele) {
    this.dialog.open(ConfirmDeleteDialogComponent)
    .afterClosed()
    .subscribe(result => {
      if(result === "true"){
        this.service.delete(ele.id)
        .subscribe(result => {
          this.msg.alert(Message.DELETE);
          let index = ELEMENT_DATA.indexOf(ele);
          ELEMENT_DATA.splice(index, 1);
          this.updateDataSource();
        })
      }else{
        return;
      }
    });
    
  }

}
